
<template>
    <v-card>
        <template v-slot:extension>
            <v-tabs v-model="tabs" centered grow>
                <v-tab :key="1" @click="weeklyBudgetCompliance = true">
                    Producción Por linea de Negocio
                </v-tab>
                <v-tab :key="2">
                    Producción por Sucursal
                </v-tab>
                <v-tab :key="3">
                    Producción por Semana Comercial
                </v-tab>
                <v-tab :key="4" @click="corportativoIngresosPorAnio = true">
                    Comparativo Ingresos por Año
                </v-tab>
            </v-tabs>
        </template>


        <v-tabs-items v-model="tabs">
            <v-tab-item>
                <v-card flat v-if="weeklyBudgetCompliance == true">
                    <v-card >
                        <WeeklyBudgetCompliance></WeeklyBudgetCompliance>
                    </v-card>
                    
                </v-card>
            </v-tab-item>
            <v-tab-item>

                <ProduccionPorSucursal></ProduccionPorSucursal>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>

                    <ProduccionPorSemanaComercial></ProduccionPorSemanaComercial>

                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat v-if="corportativoIngresosPorAnio == true">

                    <CorportativoIngresosPorAnio></CorportativoIngresosPorAnio>

                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import WeeklyBudgetCompliance from "./CumplimientoPresupuesto/WeeklyBudgetCompliance";
import ProduccionPorSucursal from "./CumplimientoPresupuesto/ProduccionPorSucursal";
import ProduccionPorSemanaComercial from "./CumplimientoPresupuesto/ProduccionPorSemanaComercial";
import CorportativoIngresosPorAnio from "./CumplimientoPresupuesto/CorportativoIngresosPorAnio";

import { EventBus } from "@/imports/EventBus";


export default {
    beforeDestroy() {
        EventBus.$off("ProduccionPorSucursal");
    },
    components: {
        WeeklyBudgetCompliance,
        ProduccionPorSucursal,
        ProduccionPorSemanaComercial,
        CorportativoIngresosPorAnio
    },
    data() {
        return {
            weeklyBudgetCompliance: true,
            corportativoIngresosPorAnio: false,
            tabs: null,
        }

    }

}



</script>
<style scoped>
.chart-container {
    width: 400px;
    height: 600px
}
</style>